import actions from './actions';
import mutations from './mutations';

const state = {
    accountForm: {
        formShowing: false
    },
    profileSettingsForm: {
        formShowing: false
    },
    mlsSettingsForm: {
        formShowing: false
    },
    generalInfoForm: {
        formShowing: false
    },
    imageSettingsForm: {
        formShowing: false
    },
    lists: {
        mlsList: [],
        stateList: [],
        timeZoneList: []
    },
    loading: {
        createNewAccount: false,
        updateAccount: false,
        formData: false,
        saveUserImage: false,
    },
    formData: {
        userId: null,
        rel_key: '',
        email: '',
        password: '',
        confirm_password: '',
        collab_approval: '1',
        allows_profile_updates: '0',
        agent_id: '',
        agent_association: '',
        f_name: '',
        l_name: '',
        company: '',
        address: '',
        address_two: '',
        city: '',
        state: '',
        zipcode: '',
        job_title: '',
        license_title: '',
        phone_office: '',
        phone_cell: '',
        website: '',
        timezone_name: Intl.DateTimeFormat().resolvedOptions().timeZone,
        profileImage: '',
        logoImage: ''
    },
    passwordRulesData: {
        rules: []
    },
    prepopulatedForm: false,
    stepActive: 0
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
